export default __webpack_public_path__ + "static/media/RaizerChairPathway(CSDonly)v2220426RaizerChairpilotv2_Page_7.fd566f13.jpg";